import { render, staticRenderFns } from "./PublicShareSidebarTrigger.vue?vue&type=template&id=35ab69be&scoped=true"
import script from "./PublicShareSidebarTrigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicShareSidebarTrigger.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublicShareSidebarTrigger.vue?vue&type=style&index=0&id=35ab69be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab69be",
  null
  
)

export default component.exports